/**
 * The "this view is refreshing itself" indicator.
 *
 * Shown while documents are still moving through the pipeline and the screen is
 * polling for them. It exists so an auto-updating number is never mistaken for a
 * stale one — the count changing under you is explained, not surprising. It is a
 * `status` live region, so a screen-reader user is told the same thing.
 */
export interface LiveBadgeProps {
  /** How many documents are still in flight. */
  count: number;
  /** Overrides the noun, e.g. "in review". Defaults to "processing". */
  verb?: string;
}

export function LiveBadge({ count, verb = 'processing' }: LiveBadgeProps): React.JSX.Element {
  return (
    <span className="ds-live" role="status">
      <span className="ds-live__dot" aria-hidden="true" />
      <span>
        {count.toLocaleString('en-GB')} {verb} · updating live
      </span>
    </span>
  );
}
